import { HttpClient } from './HttpClient.js';

export const Workplaces = {
    async getWorkplaces() {
        return await HttpClient.get('/dispatch').then(response => response);
    },

    async saveWorkplaces(form){        
        return await HttpClient.post('/dispatch', form).then(response => response);
    },

    async editStatusWorkplace(form){
        return await HttpClient.put('/dispatch/update-status/'+form).then(response => response);
    },

    async editWorkplace(id,form){        
        return await HttpClient.post('/dispatch/modifyDispatch/'+id,form).then(response => response);
    },

    async truncateTables(id,form){        
        return await HttpClient.post('/dispatch/truncate-tables/'+id,form).then(response => response);
    },

    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },

    async getMultiUsers(){
        return await HttpClient.get('/user/get-multiadmin-type').then(response => response);
    }
}
